/**
 * ACIL Intelligence - Main Layout
 * Sidebar + Topbar + Content area for authenticated pages.
 * La key en acil-content fuerza re-mount del módulo activo al cambiar de cliente.
 */
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

export default function MainLayout() {
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [selectedBranch, setSelectedBranch] = useState('nacional');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { activeClient, activeAccount } = useAuth();

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setMobileMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  useEffect(() => {
    setSelectedRegion('all');
    setSelectedBranch('nacional');
  }, [activeClient?.id, activeAccount?.id]);

  // La key cambia al seleccionar contrato, cuenta o Vista Global y fuerza
  // re-fetch de todos los módulos sin cambiar la URL.
  const contentKey = activeClient?.id
    ? `client:${activeClient.id}`
    : activeAccount?.id
      ? `account:${activeAccount.id}`
      : 'global';

  return (
    <div className="acil-layout" data-testid="main-layout">
      <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      {mobileMenuOpen && (
        <button
          type="button"
          className="acil-mobile-overlay"
          aria-label="Cerrar menú"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
      <div className="acil-main">
        <Topbar
          selectedRegion={selectedRegion}
          onRegionChange={value => {
            setSelectedRegion(value);
            setSelectedBranch('nacional');
          }}
          selectedBranch={selectedBranch}
          onBranchChange={setSelectedBranch}
          onMenuClick={() => setMobileMenuOpen(true)}
        />
        <div className="acil-content" key={contentKey}>
          <Outlet context={{
            selectedRegion,
            setSelectedRegion,
            selectedBranch,
            setSelectedBranch,
          }} />
        </div>
      </div>
    </div>
  );
}
